import React, {
  useState,
} from 'react';
import isNil from 'lodash/isNil';
import Tooltip from 'core/components/Tooltip';
import {
  isEmptyString,
} from '@populateui/utils';
import IconButton from '@mui/material/IconButton';
import ClaimNotesPopover from 'pages/Dashboard/pages/Billing/Charges/columns/ClaimNotesPopover';
import EditNoteIcon from 'core/icons/editNote';
import NotesRoundedIcon from '@mui/icons-material/NotesRounded';
import clsx from 'clsx';

type Props = {
  claimId: number;
  notes: string;
  encounterId: number;
  className?: string;
};

export default function ClaimNotes({
  encounterId,
  claimId,
  notes,
  className,
}: Props) {
  const isNotesEmpty = isEmptyString(notes);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const Icon = isNotesEmpty
    ? NotesRoundedIcon
    : EditNoteIcon;

  return (
    <>
      <Tooltip
        title={isNotesEmpty
          ? 'Add notes'
          : (
            <div className="flex flex-col gap-2 max-w-[250px]">
              <strong>Claim Notes</strong>
              <span className="whitespace-pre-wrap">
                {notes}
              </span>
            </div>
          )}
        placement={isNotesEmpty ? 'top' : 'right'}
        isInteractive
      >
        <IconButton
          size="small"
          disableRipple
          tabIndex={-1}
          color="info"
          className={clsx('!p-0.5 !rounded', className)}
          onClick={(event) => {
            event.stopPropagation();
            setAnchorEl(event.currentTarget);
          }}
        >
          <Icon className="!w-5 !h-5 -ml-1 !text-blue-500" />
        </IconButton>
      </Tooltip>
      {!isNil(anchorEl) && (
        <ClaimNotesPopover
          claimId={claimId}
          encounterId={encounterId}
          notes={notes ?? ''}
          anchorEl={anchorEl}
          onClose={() => {
            setAnchorEl(null);
          }}
        />
      )}
    </>
  );
}
